
export default {
  name: 'HeaderBadge',

  props: {
    count: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 99,
    },
  },

  computed: {
    displayCount() {
      return this.count > this.max ? `${this.max}+` : this.count
    },
  },
}
